module.exports = __webpack_public_path__ + "img/backhand_finger_down.258daa6a.png";